import { z } from 'zod';

export const OnboardingAssetOptionsSchema = z
    .object({
        mode: z.union([z.literal('report'), z.literal('report')]),
        cancel_path: z.string(),
        success_path: z.string(),
    })
    .partial();
